import { dynamicQuoteApplyURL, getReferrerKeys, updatePhoneNumber } from './campaigns';
import { cookie } from '../util/storage';

let campaignData;
const folderName = location.pathname;
const isMedSupp = folderName.match(/(?=.*medicare)(?=.*supplemental)/gm) !== null;
const isCSB = folderName.match(/(?=.*csb)/gm) !== null;

const organic = (cookieToCheck) => {
  const campaignToUse = isMedSupp ? 'CSBORG' : 'ANCORG';
  const referrerInfo = {
    google: [campaignToUse, 'Google_Search'],
    bing: [campaignToUse, 'Bing_Search'],
    yahoo: [campaignToUse, 'Yahoo_Search'],
    cigna: [campaignToUse, 'Other_Cigna_page'],
    default: [campaignToUse, 'Typed_URL']
  };

  const [referrerCode, referrerValue] = getReferrerKeys(referrerInfo);
  if (['csbMedCampaign', 'campaignPID', 'campaignEID'].some(e => cookieToCheck === e)) {
      cookie.set(cookieToCheck, referrerCode);
      const defaultPhone = $('.campaign-phone-number a').first().text().trim();
      const phoneNumber = campaignData[referrerCode] || defaultPhone;
      if (cookieToCheck === 'csbMedCampaign') {
        if ((isMedSupp && phoneNumber) || (isCSB && phoneNumber)) updatePhoneNumber(phoneNumber);
        dynamicQuoteApplyURL(referrerCode);
      }
  } else if (['campaignMedium', 'campaignSource'].some(e => cookieToCheck === e)) {
    if (cookieToCheck === 'campaignMedium') {
      const mediumToUse = isMedSupp ? referrerValue : 'Cigna Supplemental';
      cookie.set(cookieToCheck, mediumToUse);
    } else {
      cookie.set(cookieToCheck, referrerValue);
    }
  }

  if (!isMedSupp) {
    const pages = {
      'accident-expense-insurance': '18553588529',
      'cancer-insurance': '18553588530',
      'heart-stroke-insurance': '18553588531',
      'whole-life-insurance': '18553588533',
      'cancer-treatment-insurance': '18553588532',
      'hospital-indemnity-insurance': '18776308501',
      default: '18553588528'
    };

    const files = Object.keys(pages);
    const lookupPhone = files.find(e => folderName.includes(e)) || 'default';
    updatePhoneNumber(pages[lookupPhone]);
  }
};

const updateCampaign = (key, val) => {
  if (val && val !== 'ANCORG' && val !== 'CSBORG' && val !== 'Cigna Supplemental') {
    if (key === 'csbMedCampaign' || key === 'utm_campaign') {
      if ((campaignData[val] && isMedSupp) || (campaignData[val] && isCSB)) {
        cookie.set('csbMedCampaign', val);
        updatePhoneNumber(campaignData[val]);
        dynamicQuoteApplyURL(val);
      } else {
        organic('csbMedCampaign');
      }
    } else if (key === 'campaignMedium' || key === 'utm_medium') {
      cookie.set('campaignMedium', val);
    } else if (key === 'campaignSource' || key === 'utm_source') {
      cookie.set('campaignSource', val);
    } else if (key === 'campaignPID' || key === 'PID') {
      cookie.set('campaignPID', val);
    } else if (key === 'campaignEID' || key === 'EID') {
      cookie.set('campaignEID', val);
    }
  } else {
    organic(key);
  }
};

const processCampaignURL = () => {
  if (location.search === '') {
    ['campaignMedium', 'campaignSource', 'campaignPID', 'campaignEID', 'csbMedCampaign'].forEach(element => organic(element));
  } else {
    const [, searchString] = location.search.split('?');
    const searchValuesObj = {};

    searchString.split('&').forEach((element) => {
      const [key, val] = element.split('=');
      searchValuesObj[key] = val;
    });
    /* eslint-disable no-confusing-arrow */
    [
      { query: 'utm_medium', cookie: 'campaignMedium' },
      { query: 'utm_source', cookie: 'campaignSource' },
      { query: 'PID', cookie: 'campaignPID' },
      { query: 'EID', cookie: 'campaignEID' },
      { query: 'utm_campaign', cookie: 'csbMedCampaign' }
    ].forEach(element => searchValuesObj[element.query]
    ? updateCampaign(element.query, searchValuesObj[element.query])
    : updateCampaign(element.cookie));
  }
};
export default (jsonData) => {
  campaignData = jsonData;
  if (cookie.get('csbMedCampaign') && !location.search.includes('utm_campaign')) {
    ['campaignMedium', 'campaignSource', 'campaignPID', 'campaignEID', 'csbMedCampaign'].forEach(element => updateCampaign(element, cookie.get(element)));
  } else {
    processCampaignURL();
  }
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/campaigns/csb-medical.js